import { render, staticRenderFns } from "./immediatelyPay.vue?vue&type=template&id=20d86f56&scoped=true&"
import script from "./immediatelyPay.vue?vue&type=script&lang=js&"
export * from "./immediatelyPay.vue?vue&type=script&lang=js&"
import style0 from "./immediatelyPay.vue?vue&type=style&index=0&id=20d86f56&lang=less&scoped=true&"
import style1 from "./immediatelyPay.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d86f56",
  null
  
)

export default component.exports